// Directory logic
export default ($) => {
    let _form           = $('.directory-form');
    let _searchResult   = $('.directory-search');
    let $_personCards   = $('.js-person-card');
    let searchNumber    = $('.js-searchNumber');
    let checkboxButtons = $('.js-directory-choice')
    let subfactultyBtns = $('.js-faculty-subchoice');
    let subcats         = $('#subfaculty-categories');
    let hasSubcats      = subcats.length;
    let _checkedResults = '';
    let _subResults     = '';
    let _loadMoreDir    = $('.js-load-more-directory');
    let _loadMoreBtn    = $('.js-load-more-directory-button');
    let _showCount      = _loadMoreBtn.data('show');
    let _loadCount      = _loadMoreBtn.data('load');
    let _searchInfo     = $('.js-search-info');
    let _searchInfoVal  = $('.js-search-info-value');
    let totalResults    = 0;

    checkboxButtons.on('change', function () {
        let checked = $('.js-directory-choice:checked');
        let values = '';
        let thisValue = $(this).val();
        let thisChecked = $(this).is(':checked');

        if (thisValue === 'faculty') {

            if (!thisChecked) {
                subfactultyBtns.prop('checked', false);
                subfactultyBtns.change();
                subcats.hide();
            } else {
                subcats.show();
            }
        }

        for (let i = 0; i < checked.length; i++) {
            values+= '.' + $(checked[i]).val();

            if (i + 1 !== checked.length) {
                values+= ', ';
            }
        }

        _checkedResults = values;

        filterFn();
    });

    subfactultyBtns.on('change', function () {
        let checked = $('.js-faculty-subchoice:checked');
        let values = '';

        for (let i = 0; i < checked.length; i++) {
            values+= '.' + $(checked[i]).val();

            if (i + 1 !== checked.length) {
                values+= ', ';
            }
        }

        _subResults = values;

        filterFn();
    });

    _form.on('submit', (e) => {
        e.preventDefault();

        filterFn();
    });

    _loadMoreBtn.on('click', () => {
        let hiddenElements = $('.js-person-card.hidden:not(.removed)');
        let countHidden = hiddenElements.length;

        for (let i = 0; i < _loadCount; i++) {
            if ($(hiddenElements[i])) {
                $(hiddenElements[i]).removeClass('hidden');
            }
        }

        if (countHidden < _loadCount + 1) {
            _loadMoreDir.addClass('hidden');
        }
    });

    function filterFn () {
        let filters = _searchResult.val().split(/\s/).filter(s => s.trim().length > 0).map(s => new RegExp(`${s}`, 'gi'));

        if (_searchResult && _searchResult.val()) {
            _searchInfo.show();
            _searchInfoVal.text(_searchResult.val());
        } else {
            _searchInfo.hide();
        }

        $_personCards = $('.js-person-card');
        $_personCards.removeClass('hidden removed');
        $_personCards.each((index, item) => {
            if (_checkedResults) {
                $(item).toggleClass('removed', !$(item).is(_checkedResults));
            } else {
                $(item).removeClass('removed');
            }

            if (hasSubcats) {

                if (_subResults) {
                    $(item).toggleClass('removed', !$(item).is(_subResults));
                }
            }

            if (_searchResult.val() && !$(item).hasClass('removed')) {
                item.classList.toggle('removed', !filters.some(regex => item.innerText.match(regex)));
            }
        });

        $_personCards = $('.js-person-card:not(.removed)');
        totalResults = $_personCards.length;

        $_personCards.each((index, item) => {
            $(item).toggleClass('hidden', index > _showCount - 1);
        });

        searchNumber.text(totalResults);

        _loadMoreDir.toggleClass('hidden', totalResults < _showCount + 1);
    }

    checkboxButtons.change();
}